export var DEPLOY_DATE = new Date('2026-07-27T13:19:56+0000');
